import { render } from "./BaseItemBox.vue?vue&type=template&id=7f85bf42&ts=true"
import script from "./BaseItemBox.vue?vue&type=script&lang=ts"
export * from "./BaseItemBox.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__